import { Helmet } from "react-helmet-async";
import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-page-modern">
      <Helmet>
        <title>Privacy Policy | WLE Technology Ventures Sdn Bhd</title>
        <meta name="description" content="Privacy Policy for WLE Technology Ventures Sdn Bhd and WLE Ventures. Learn how we collect, use, and protect your personal information." />
        <link rel="canonical" href="https://wletec.com/privacy-policy" />
        <meta name="robots" content="noindex, follow" />
      </Helmet>
      <Navigation />
      
      <main className="py-20">
        <div className="container mx-auto px-4 max-w-4xl">
          <div className="text-center mb-12">
            <h1 className="text-4xl font-bold mb-4">Privacy Policy</h1>
            <p className="text-muted-foreground">Last updated: December 13, 2025</p>
          </div>

          <div className="space-y-8">
            <Card>
              <CardHeader>
                <CardTitle>Information We Collect</CardTitle>
              </CardHeader>
              <CardContent className="space-y-4">
                <p>
                  WLE Technology Ventures Sdn Bhd and WLE Ventures ("we," "our," or "us") collect information you provide directly to us, such as when you:
                </p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Contact us through our website forms</li>
                  <li>Request quotes or information about our services</li>
                  <li>Communicate with us via email or phone</li>
                  <li>Visit our facility or attend meetings</li>
                </ul>
                <p>
                  This may include your name, email address, phone number, company information, and details about your project requirements.
                </p>
              </CardContent>
            </Card>

            <Card>
              <CardHeader>
                <CardTitle>How We Use Your Information</CardTitle>
              </CardHeader>
              <CardContent className="space-y-4">
                <p>We use the information we collect to:</p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Respond to your inquiries and provide customer service</li>
                  <li>Prepare quotes and proposals for tank fabrication services</li>
                  <li>Communicate about our services and projects</li>
                  <li>Improve our website and services</li>
                  <li>Comply with legal obligations</li>
                </ul>
              </CardContent>
            </Card>

            <Card>
              <CardHeader>
                <CardTitle>Information Sharing</CardTitle>
              </CardHeader>
              <CardContent className="space-y-4">
                <p>
                  We do not sell, trade, or rent your personal information to third parties. We may share your information only in the following circumstances:
                </p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>With your consent</li>
                  <li>To comply with legal requirements</li>
                  <li>With trusted service providers who assist in our operations</li>
                  <li>To protect our rights and property</li>
                </ul>
              </CardContent>
            </Card>

            <Card>
              <CardHeader>
                <CardTitle>Data Security</CardTitle>
              </CardHeader>
              <CardContent className="space-y-4">
                <p>
                  We implement appropriate security measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the internet is 100% secure.
                </p>
              </CardContent>
            </Card>

            <Card>
              <CardHeader>
                <CardTitle>Your Rights</CardTitle>
              </CardHeader>
              <CardContent className="space-y-4">
                <p>You have the right to:</p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Access your personal information</li>
                  <li>Correct inaccurate information</li>
                  <li>Request deletion of your information</li>
                  <li>Opt out of marketing communications</li>
                </ul>
              </CardContent>
            </Card>

            <Card>
              <CardHeader>
                <CardTitle>Contact Us</CardTitle>
              </CardHeader>
              <CardContent className="space-y-4">
                <p>
                  If you have questions about this Privacy Policy or our data practices, please contact us:
                </p>
                <div className="space-y-4">
                  <div className="space-y-2">
                    <p><strong>WLE Technology Ventures Sdn. Bhd.</strong></p>
                    <p>202601037405 (1699500-H)</p>
                    <p>7, Jalan Utarid U5/17</p>
                    <p>Mahsing Integrated Industrial Park</p>
                    <p>Seksyen U5, 40150 Shah Alam, Selangor Darul Ehsan, Malaysia</p>
                    <p>Phone: +6011 3906 9019</p>
                    <p>Email: enquiry@wletec.com</p>
                  </div>
                  <div className="space-y-2 pt-4 border-t">
                    <p><strong>WLE Ventures (Malaysia)</strong></p>
                    <p>7, Jalan Utarid U5/17</p>
                    <p>Mahsing Integrated Industrial Park</p>
                    <p>Seksyen U5, 40150 Shah Alam, Selangor Darul Ehsan, Malaysia</p>
                    <p>Phone: +6011 3906 9019</p>
                    <p>Email: enquiry@wletec.com</p>
                  </div>
                </div>
              </CardContent>
            </Card>

            <Card>
              <CardHeader>
                <CardTitle>Changes to This Policy</CardTitle>
              </CardHeader>
              <CardContent>
                <p>
                  We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last updated" date.
                </p>
              </CardContent>
            </Card>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default PrivacyPolicy;